// dependencies imports ⇒
import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

// assets and scss imports ⇒
import "./abhaTokenViewContainer.scss";
import SuccessIcon from "../../assets/check.png";
import warningIcon from "../../assets/warning_blue.svg";

// project file imports(UI components) ⇒
import AbhaTokenViewTableContent from "./AbhaTokenViewTableContent";
import CommonPopup from "../common/CommonPopup";
import C2CMiddlePopup from "../common/Popups/C2CMiddlePopup";
import AbhaConfirmationDetails from "../common/AbhaConfirmationDetails";
import AbhaDetailsViewContent from "./AbhaDetailsViewContent";
import C2CCustomPopup from "../common/Popups/C2CCustomPopup";
import PhysicalConsultationModal from "../PhysicalConsultation";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";
import { GET_STATE, UPDATE_PATIENT_DETAILS_WITH_ABHA } from "./apiConstant";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import { PROD } from "../common/config";

// const file imports(helper methods, etc) ⇒

const AbhaTokenViewContainer = (props) => {
  // const declarations ⇒
  const { showAbhaTokenContainer, handleCloseAbhaContainer, selectedClinic } =
    props;
  const [showMobFilter, setShowMobFilter] = useState(false);
  const [showAbhaTokenModal, setShowAbhaTokenModal] = useState(false);
  const [showAbhaDetailsModal, setShowAbhaDetailsModal] = useState(false);
  const [showAbhaConfirmationModal, setShowAbhaConfirmationModal] =
    useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showPhysicalConsultationModal, setShowPhysicalConsultationModal] =
    useState(false);
  const [abhaPatientDetails, setAbhaPatientDetails] = useState({});
  const [existingPatientDetails, setExistingPatientDetails] = useState({});
  const [isAddNewAbhaPatient, setIsAddNewAbhaPatient] = useState(false);

  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);

  // let or var declarations ⇒

  // life cycle methods ⇒
  useEffect(() => {
    if (showAbhaTokenContainer) {
      setShowAbhaTokenModal(true);
    }
  }, [showAbhaTokenContainer]);

  // API Calls ⇒

  const updatePatientDetailsWithAbhaAPICall = (payload) => {
    const updatedDetailsResponse = c2cPostApiHandler(
      UPDATE_PATIENT_DETAILS_WITH_ABHA,
      payload
    );
    updatedDetailsResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        setShowAbhaConfirmationModal(false);
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
          handleClosePopup();
        }, 2000);
      } else {
        setShowAbhaConfirmationModal(false);
      }
    });
  };

  const getStateAPICall = (patinentDetails) => {
    let payload = {
      pincode: patinentDetails?.patient_pincode,
    };
    c2cPostApiHandler(GET_STATE, payload).then(([res, err]) => {
      if (!err && res.data.statusCode === 200) {
        let finalPatientDetails = {
          ...patinentDetails,
          patient_state: res?.data?.data?.state_name,
        };
        setExistingPatientDetails(finalPatientDetails);
        setShowAbhaDetailsModal(false);
        setShowAbhaConfirmationModal(true);
      } else {
        setExistingPatientDetails(patinentDetails);
        setShowAbhaDetailsModal(false);
        setShowAbhaConfirmationModal(true);
      }
    });
  };

  // Helper methods ⇒
  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Actions ⇒

  const onAbhaTokenFilterOpen = () => {
    setShowMobFilter(true);
  };

  const onhandleViewDetails = (patientDetails) => {
    let obj = {
      ...patientDetails,
      abha_address: patientDetails?.abha_address
        ? patientDetails?.abha_address?.split("@")[0]
        : "",
      state_name: patientDetails?.state,
    };
    setAbhaPatientDetails(obj);
    setShowAbhaTokenModal(false);
    setShowAbhaDetailsModal(true);
  };

  const handleClosePopup = () => {
    handleCloseAbhaContainer();
  };

  const handleShowConfirmationModal = (patinentDetails) => {
    getStateAPICall(patinentDetails);
  };

  const handleNoConfirmationModal = () => {
    let payload = {
      patient_account_id: existingPatientDetails?.patient_account_id,
      patient_abha_address: abhaPatientDetails?.abha_address,
    };
    updatePatientDetailsWithAbhaAPICall(payload);
  };

  const handleYesConfirmationModal = () => {
    let payload = {
      name: abhaPatientDetails?.name,
      gender: abhaPatientDetails?.gender,
      dob: abhaPatientDetails?.dob,
      patient_account_id: existingPatientDetails?.patient_account_id,
      patient_abha_address: abhaPatientDetails?.abha_address,
      patient_address: abhaPatientDetails?.address,
    };
    updatePatientDetailsWithAbhaAPICall(payload);
  };

  const handleAddNewPatient = () => {
    setShowAbhaConfirmationModal(false);
    setShowPhysicalConsultationModal(true);
    setExistingPatientDetails({});
    setIsAddNewAbhaPatient(true);
  };

  const handleBookAppointment = (patientDetails) => {
    setExistingPatientDetails(patientDetails);
    setIsAddNewAbhaPatient(false);
    setShowAbhaConfirmationModal(false);
    setShowPhysicalConsultationModal(true);
  };

  const handleAbhaDetails = (phNo) => {
    setAbhaPatientDetails({
      ...abhaPatientDetails,
      phone_number: phNo,
    });
  };
  // create UI ⇒

  const abhaTokenViewContainer = () => {
    return (
      <div>
        <AbhaTokenViewTableContent
          showMobFilter={showMobFilter}
          setShowMobFilter={setShowMobFilter}
          onhandleViewDetails={onhandleViewDetails}
        />
      </div>
    );
  };

  const abhaFilterIcon = () => {
    return (
      <div
        className="abha-token-filter-icon-wrapper"
        onClick={onAbhaTokenFilterOpen}
      >
        <FilterAltIcon className="abha-token-filter-icon" />
      </div>
    );
  };

  const abhaFilterUi = (
    <div className="abha-token-heading-filter-wrapper">
      {" ABHA Tokens"}
      {window.innerWidth < 768 && abhaFilterIcon()}
    </div>
  );

  return (
    <div className="abha-token-view-container">
      <CommonPopup
        openPopup={showAbhaTokenModal}
        classes={{
          dialogPaper: "abha-token-view-modal",
        }}
        handleClosePopup={handleClosePopup}
        heading={abhaFilterUi}
        subtitle={abhaTokenViewContainer()}
        rightBtn="Cancel"
        hideFooter={true}
        hideCloseText={true}
      ></CommonPopup>

      <C2CCustomPopup
        openPopup={showAbhaDetailsModal}
        popupHeading="ABHA Details"
        dialogClassName="abha-token-details-popup"
        handleClosePopup={handleClosePopup}
      >
        <AbhaDetailsViewContent
          abhaPatientDetails={abhaPatientDetails}
          handleShowConfirmationModal={handleShowConfirmationModal}
          handleAddNewPatient={handleAddNewPatient}
          handleBookAppointment={handleBookAppointment}
          handleAbhaDetails={handleAbhaDetails}
        />
      </C2CCustomPopup>

      <C2CMiddlePopup
        openPopup={showAbhaConfirmationModal}
        hideCloseIcon={false}
        titleImg={window.innerWidth < 768 && warningIcon}
        dialogClassName="abha-token-confirmation-modal"
        title={"Confirmation!"}
        subtitle={
          <span>
            Patient Details will be updated as per <br />
            the ABHA Address
            <b> "{getAbhaAddress(abhaPatientDetails?.abha_address)}". </b>
            Do you want to continue ?
          </span>
        }
        leftBtn={"Yes"}
        rightBtn={"No"}
        handleLeftBtnClick={handleYesConfirmationModal}
        handleRightBtnClick={handleNoConfirmationModal}
        handleClosePopup={() => {
          setShowAbhaConfirmationModal(false);
          handleClosePopup();
        }}
      >
        <AbhaConfirmationDetails
          appointmentDetails={existingPatientDetails}
          abhPatientDetails={abhaPatientDetails}
        />
      </C2CMiddlePopup>

      <C2CMiddlePopup
        openPopup={showSuccessModal}
        hideCloseIcon={true}
        dialogClassName="abha-token-success-modal"
        titleImg={SuccessIcon}
        title={"Success Linked appointment With Patient ABHA ID!"}
      />

      {showPhysicalConsultationModal && (
        <PhysicalConsultationModal
          appointmentType={"in-clinic"}
          // appointmentId={appointment.appointment_id}
          doctor_slug={""}
          closeView={() => {
            setShowPhysicalConsultationModal(false);
            handleClosePopup();
          }}
          openView={showPhysicalConsultationModal}
          isAddMode={true}
          step={1}
          doctorData={{
            is_resource:
              selectedClinic?.is_clinic_and_lab === "True" &&
              (doctorRole === USER_ROLE.RESOURCE_ADMIN ||
                doctorRole === USER_ROLE.RESOURCE_CONSULTANT)
                ? "True"
                : "False",
          }}
          // callNextAppointmentWidget={props?.callNextAppointmentWidget}
          // handleSetAppointmentType={showSetAppointmentType}
          addBooking={
            selectedClinic?.is_clinic_and_lab === "True" &&
            (doctorRole === USER_ROLE.DOCTOR_ADMIN ||
              userType === USER_TYPE.STAFF)
          }
          abhaPatientDetails={abhaPatientDetails}
          isAddNewAbhaPatient={isAddNewAbhaPatient}
          existingPatientDetails={existingPatientDetails}
          isAbhaTokenBooking={true}
        />
      )}
    </div>
  );
};

// export ⇒

export default AbhaTokenViewContainer;
